import React, { useEffect, useState } from 'react'
import { addRoute } from '../../../store/actions/route'

// Redux 
import { useDispatch, useSelector } from 'react-redux'
import { userTokenUpdate, userLogout } from '../../../store/actions/user';
import { addManager, deleteManager, getManagers } from '../../../store/actions/managers';

// Components
import AdminManagersForm from './AdminManagersForm';
import AdminManagersList from './AdminManagersList';
import GeneralLoader from '../../GeneralLoader';
import SuccessWrap from '../../utils/error-success/SuccessWrap';
import ErrorWrap from '../../utils/error-success/ErrorWrap';


const AdminManagers = () => {
    const [formData, setFormData] = useState({
        email: ''
    });
    const dispatch = useDispatch();
    const {
        managersLoading, managersError, managersSuccess, managers
    } = useSelector(state => state.managers);


    useEffect(() => {
        dispatch(addRoute({
            type: '',
            route: '/admin/specialists'
        }))

        // Fetch managers from API and store into state 
        dispatch(getManagers()).then((resp) => {
            if (resp.data.status === 403) {
                dispatch(userLogout("admin"));
                return;
            }
        })

    }, [])

    const handleInputChange = (event) => {
		const { id, value } = event.target;

        setFormData((formData) => ({
            ...formData,
            [id]: value
        }))
    }

    const handleDeleteManager = (id) => {
        // Confirmation for deleting of a manager. If true delete, if cancel do nothing
        if (window.confirm('Are you sure you wish to delete this manager?')) {
            dispatch(deleteManager(id)).then((response) => {
                if (!!response.data.token) {
                    dispatch(userTokenUpdate("admin", response.data.token));
                }
                if (response.data.status === 403) {
                    dispatch(userLogout("admin"));
                    return;
                }
                // Load managers again
                dispatch(getManagers());
            });
        } else {
            return;
        }
    }

    const handleAddManager = () => {
        dispatch(addManager(formData)).then((response) => {
            if (!!response.data.token) {
                dispatch(userTokenUpdate("admin", response.data.token));
            }
            if (response.data.status === 403) {
                dispatch(userLogout("admin"));
                return;
            }
        });
    }
    
    return (
        <React.Fragment>
            <div className="linked-title">
                <h1>Manage Specialists</h1>
            </div>

            {managersLoading ? <GeneralLoader/> :
                <React.Fragment>
                    <AdminManagersForm
                        data={formData}
                        loading={managersLoading}
                        errors={managersError}
                        handleInputChange={e => handleInputChange(e)}
                        handleAddManager={() => handleAddManager()}
                    />

                    {!!managersError.general && (
                        <ErrorWrap animate={1}>{managersError.general}</ErrorWrap>
                    )}
                    {managersSuccess && <SuccessWrap>{managersSuccess}</SuccessWrap>}
                    
                    <AdminManagersList
                        loading={managersLoading}
                        managers={managers}
                        handleDeleteManager={id => handleDeleteManager(id)}
                    />
                </React.Fragment>
            }
        </React.Fragment>

    )
}

export default AdminManagers


// WEBPACK FOOTER //
// ./src/components/admin/managers/AdminManagers.js